export const OPEN_BUILDHUB_CHAT_EVENT = 'buildhub:open-chat';

export type OpenBuildHubChatDetail = {
  source?: string;
};

let pendingOpenSource: string | undefined;

export const openBuildHubChat = (source = 'site_cta') => {
  pendingOpenSource = source;
  window.dispatchEvent(new CustomEvent<OpenBuildHubChatDetail>(OPEN_BUILDHUB_CHAT_EVENT, {
    detail: { source },
  }));
};

export const consumePendingBuildHubChat = () => {
  const source = pendingOpenSource;
  pendingOpenSource = undefined;
  return source;
};
